export default "/048cb1f2b29308e18768c65cfd51e426596a830c/b3dc542ec1b5794376b3d1da54a4e35b.svg";